export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS';
export const REFRESH_FAILED = 'REFRESH_FAILED';
export const TOGGLE_SUDO_MODAL = 'TOGGLE_SUDO_MODAL';
